import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "../../supabase";
import { toast, ToastContainer } from "react-toastify";
import logo from "../assets/images/logo.webp";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  // ✅ Check if already logged in
  useEffect(() => {
    const { data: listener } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (session) {
          navigate("/admin-live-bookings");
        }
      },
    );

    return () => {
      listener.subscription.unsubscribe();
    };
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      setError(error.message);
      toast.error(error.message);
      setLoading(false);
    } else {
      toast.success("Logged in successfully");
      setLoading(false);
      navigate("/admin-live-bookings");
    }
  };

  return (
    <>

      <div className="d-flex align-items-center justify-content-center">
        <div
          className="login-card mt-5 shadow p-4 rounded"
          style={{ width: "100%", maxWidth: "350px" }}
        >
          <div className="text-center mb-4">
            <h3 className="mb-0">
              <img
                src={logo}
                style={{ width: "170px" }}
                className="img-fluid"
              />
            </h3>
            <p className="text-muted">Sign in to continue</p>
            <hr />
          </div>

          <form onSubmit={handleSubmit}>
            <label className="form-label">Registered Email</label>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{ width: "100%" }}
              placeholder="Enter email"
              required
            />

            <label className="form-label mt-2">Password</label>
            <div className="ui right labeled input" style={{ width: "100%" }}>
              <input
                className="form-control"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password.."
                required
              />
              <div
                className="ui basic label"
                style={{ cursor: "pointer" }}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <i className="fa fa-eye-slash" />
                ) : (
                  <i className="fa fa-eye" />
                )}
              </div>
            </div>

            <div className="text-center">
              <button
                className="btn btn-dark w-100 mt-3"
                type="submit"
                disabled={loading}
              >
                {loading ? "Loading. Please wait..." : "Login"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;
